import type { ISanctionBreach, ISanctionConsequence, ISanctionEvent } from "@bbj-types/sanction";
import type { TSanctionPhase } from "@bbj-types/sanction/enums";
import { useCallback } from "react";
import type { TSanction } from "../candidates";
import { axiosV2 } from "../candidates/axios";

export interface IGetConsequenceResponseDetail {
  consequence: ISanctionConsequence;
  evenements: ISanctionEvent[];
  manquement: ISanctionBreach;
  identifiantManquement: string;
}

export interface IGetConsequenceResponse {
  idConsequenceSanction: string;
  numeroFranceTravail: string;
  detail: IGetConsequenceResponseDetail;
  decisionComment?: string;
  type?: TSanction;
  phase?: TSanctionPhase;
}

export const useGetConsequence = () => {
  const [state, execute, cancel] = axiosV2<IGetConsequenceResponse>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (idConsequenceSanction: string) =>
      execute({
        url: `/candidates/sanctions/${idConsequenceSanction}`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
